import { render, staticRenderFns } from "./ModuleSelectMenu.vue?vue&type=template&id=7e43af80"
import script from "./ModuleSelectMenu.vue?vue&type=script&lang=js"
export * from "./ModuleSelectMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports